'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.provider('userStore', function(localStorageEnabled, StoreTemplate, otppConstants) {
  // Model data
  let memberIrn, accountHash, recentlyLoggedOut;
  // currentUserDetails holds the first name and homepage modules of the user.
  let currentUserDetails = {};

  const LOCALSTORAGE_KEYS = {
    accountHash: 'mbr.accountHash',
    firstName: 'mbr.firstName'
  };

  //DMWS-1115, let header show username during refresh
  if(sessionStorage.getItem(LOCALSTORAGE_KEYS.firstName)!==undefined){
    currentUserDetails.firstName=sessionStorage.getItem(LOCALSTORAGE_KEYS.firstName);
  }

  /*
    In order to use a service within the Store, we have to create a new Angular injector and get the service
    from it. Unfortunately, that means that the $cookies service used here doesn't pick up the $cookiesProvider
    defaults set in app.js. This isn't a great solution; calls to $cookies should probably be set up in the
    service layer rather than the store, I think, but that would be a big refactoring.
   */
  var $cookies = angular.injector(['ngCookies']).get('$cookies');

  function setFirstNameCookie(firstName) {
    const THIRTY_MINUTES_IN_MS = 1000 * 60 * 30;
    const datePlusThirty = new Date(Date.now() + THIRTY_MINUTES_IN_MS);
    $cookies.put(otppConstants.mbrAuthKey, firstName, {path: '/',
      expires: datePlusThirty, samesite: 'none', Secure: ''});
    window.dispatchEvent(new CustomEvent('MbrAuthCookieSet'));
  }

  function clearFirstNameCookie() {
    $cookies.remove(otppConstants.mbrAuthKey, {path: '/'});
    $cookies.remove(otppConstants.bamKey, {path: '/'});
  }

  return StoreTemplate.extend({
    getterFns: {
      getIrn() {
        return memberIrn;
      },
      getAccountHash() {
        return accountHash;
      },
      getFirstName() {
        return currentUserDetails.firstName;
      },
      getUser() {
        let userObj = angular.copy(currentUserDetails);
        if (memberIrn) {
          userObj.irn = memberIrn;
          userObj.accountMask = '******' + memberIrn.slice(-3);
        }
        if (accountHash) {
          userObj.accountHash = accountHash;
        }

        return userObj;
      },
      getRecentlyLoggedOut() {
        return recentlyLoggedOut;
      },
      getMemberStatus() {
        return currentUserDetails.memberStatus;
      },
      getSurvivorPensioner() {
        return currentUserDetails.survivorPensioner;
      }
    },
    dispatcherListeners: {
      'user:setUserAccount'(userObj) {
        if (angular.isObject(userObj)) {
          memberIrn = userObj.irn || null;
          accountHash = userObj.accountHash;
          if (localStorageEnabled) {
            localStorage.setItem(LOCALSTORAGE_KEYS.accountHash, userObj.accountHash);
          }
        }
      },
      'user:setUserDetails'(userDetailsObj) {
        currentUserDetails.firstName = userDetailsObj.firstName;
        currentUserDetails.memberStatus = userDetailsObj.memberStatus;
        currentUserDetails.survivorPensioner = userDetailsObj.survivorPensioner;
        setFirstNameCookie(userDetailsObj.firstName);
        if (userDetailsObj.accountMask) {
          currentUserDetails.accountMask = userDetailsObj.accountMask;
        }
        if (localStorageEnabled) {
          sessionStorage.setItem(LOCALSTORAGE_KEYS.firstName, userDetailsObj.firstName);
        }
      },
      'user:removeCurrentUser'() {
        memberIrn = null;
        accountHash = null;
        recentlyLoggedOut = null;
        currentUserDetails = {};

        if (localStorageEnabled) {
          sessionStorage.removeItem(LOCALSTORAGE_KEYS.firstName);
          localStorage.removeItem(LOCALSTORAGE_KEYS.accountHash);
        }

        clearFirstNameCookie();
      },
      'user:setRecentlyLoggedOut'(value) {
        recentlyLoggedOut = value;
      }
    }
  });
});
